// @flow
import React from 'react';

import Box from '@waglabs/box';
import { EmailLink } from '@waglabs/email-link';
import H2 from '@waglabs/h2';
import Text from '@waglabs/text';
import Span from '@waglabs/span';

import { BodyContainer } from '../../../BodyContainer';
import { WAG_TAG_EMAIL } from '../../../../constants';
import wagTagsImage from './assets/wag-tags.jpg';

const AdditionalQuestionsContent = () => (
  <>
    <H2
      color="white"
      fontFamily="body"
      fontWeight="bold"
      fontSize={8}
      mb={[3, 4]}
    >
      Have any questions?
    </H2>
    <Text
      color="white"
      fontFamily="body"
      fontSize={4}
    >
      We’re happy to help, just send a note to:
      <Box>
        <EmailLink
          email={WAG_TAG_EMAIL}
        >
          <Span
            color="champagne"
            fontWeight="bold"
          >
            {WAG_TAG_EMAIL}
          </Span>
        </EmailLink>
        .
      </Box>
    </Text>
  </>
);

export const AdditionalQuestions = () => (
  <>
    <Box
      display={['none', 'block']}
    >
      <Box
        backgroundImage={`url(${wagTagsImage})`}
        backgroundPosition={['center']}
        backgroundSize="cover"
      >
        <BodyContainer
          alignItems="flex-end"
          flexDirection="row"
          px={[0, 4]}
          py={[0, 5, '100px']}
        >
          <Box
            width="50%"
          />
          <Box
            width="50%"
            pl={5}
          >
            <AdditionalQuestionsContent />
          </Box>
        </BodyContainer>
      </Box>
    </Box>

    <Box
      bg="shelterGreen"
      display={['block', 'none']}
      p={4}
      mb={5}
    >
      <AdditionalQuestionsContent />
    </Box>
  </>
);
